// When the schedule is grouped, a user gets one row per group they belong to,
// so the row id is `${userId}_${groupId}`. Slice it back before sending it to the api.
const SEPARATOR = "_";

export const getGroupedResourceId = (userId: string, groupId: string | number) =>
    `${userId}${SEPARATOR}${groupId}`;

export const getResourceUserId = <T,>(resourceId: T): T => {
    if (typeof resourceId !== "string") return resourceId;
    const index = resourceId.indexOf(SEPARATOR);
    return (index === -1 ? resourceId : resourceId.slice(0, index)) as T;
};

// The row resource with the real user id, for places that read `user.id`
export const getResourceUser = (resource: any) =>
    resource?.id ? { ...resource, id: getResourceUserId(resource.id) } : resource;
